import { User } from "./User";

export class Me extends User {
  schema = "/me";
  constructor(params = {}) {
    return super(params, "/me");
  }
}
